import { PROJECT_STATUSES } from 'Constants';
import React, { useEffect, useRef } from 'react';
import { useDrag } from 'react-dnd';

import { useFloorplanContext } from '../context';

import { isSafetracesAdmin } from 'Config/roles';
import { isViewer } from 'Config/roles';

const PlaceableOPItem = ({ op, markerSize }) => {
  const {
    testData,
    projectData,
    location,
    overrideColorPointId,
    setFocusOnTextField,
  } = useFloorplanContext();

  const itemRef = useRef(null);

  const canDragSTAdmin =
    (!!projectData?.status &&
      projectData?.status !== PROJECT_STATUSES.PUBLISHED) ||
    location === 'heatmapPage';

  const canDragAnyUser =
    !isViewer() &&
    typeof testData?.testexecuted === 'boolean' &&
    !testData.testexecuted;

  useEffect(() => {
    if (location === 'heatmapPage') {
      addOnCLickListeners();
    }
  }, []);

  const [, drag] = useDrag({
    type: 'OP',
    item: {
      ...op,
      type: 'OP',
      id: op.opid,
    },
    canDrag: isSafetracesAdmin() ? canDragSTAdmin : canDragAnyUser,
  });

  // Adjust icon and font size
  const width = 100 * (markerSize / 7.5) ?? 50;
  const fontSize = 8 * (markerSize / 3) ?? 16;

  // Place the icon in the middle
  const left = op.opcoordx - width / 2;
  const top = op.opcoordy - width / 2;

  const addOnCLickListeners = () => {
    const el = document.getElementById(`placeable-op-item-${op.opid}`);
    if (!el) return;

    el.addEventListener('mousedown', () => {
      itemRef.current = {
        shouldFocusOnTextField: true,
      };
      setTimeout(() => {
        itemRef.current = null;
      }, 500);
    });
    el.addEventListener('mouseup', () => {
      if (itemRef.current?.shouldFocusOnTextField) {
        setFocusOnTextField(`OP-${op.opid}`);
      }
    });
  };

  if (op.opcoordx >= 0 || op.opcoordy >= 0) {
    return (
      <div
        id={`placeable-op-item-${op.opid}`}
        ref={drag}
        className="object"
        style={{
          position: 'absolute',
          left,
          top,
          width: `${width}px`,
          height: `${width * 0.6}px`,
        }}
      >
        <svg height="100%" width="100%" preserveAspectRatio="xMidYMid meet">
          <rect
            width="100%"
            height="100%"
            fill={
              !overrideColorPointId
                ? 'saddlebrown'
                : overrideColorPointId === `OP-${op.opid}`
                ? 'green'
                : 'grey'
            }
          />
          <rect x="10%" y="15%" width="80%" height="70%" fill="linen" />
          <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            fontSize={`${fontSize}px`}
          >
            {op.opnumber}
          </text>
        </svg>
      </div>
    );
  }
  return null;
};

export default PlaceableOPItem;
